/* eslint-disable react-hooks/rules-of-hooks */
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpStatus, VisImpSwitchImage} from '../../models/visuallyImpairedSettings';
import {IconProps} from './model';
import View from './view';

export const SvgHoc = ({source, isNeedModification}: {source: unknown; isNeedModification?: boolean}) => {
  return (props: IconProps) => {
    const {switchImages, visuallyImpaired} = useSelector(themeSelector());

    const hide =
      visuallyImpaired === VisImpStatus.Active &&
      switchImages === VisImpSwitchImage.False &&
      !!props.hideForVisuallyImpaired;
    const gray = visuallyImpaired === VisImpStatus.Active;
    const background = visuallyImpaired === VisImpStatus.Active ? props.background : 'none';

    return View({...props, hide, gray, source, background, isNeedModification});
  };
};
